import { tu360Compras } from "./compras.json";
import { tu360Inmobiliario } from "./inmobiliario.json";
import { tu360Movilidad } from "./movilidad.json";

export const transversalJSON = [
  tu360Inmobiliario,
  tu360Movilidad,
  tu360Compras
];
